import React, { useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { useOrganizations, useProperties } from 'hooks';
import SimpleTable from 'components/table/SimpleTable';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MobileTable from 'components/table/MobileTable';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
    paddingBottom: '0px !important',
    overflowY: 'auto',
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  visibleSmall: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  buttonFormat: {
    zIndex: 10,
  },
}));

function PropertyTable({ className, ...rest }) {
  const classes = useStyles();
  const mobileView = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const { t } = useTranslation();
  const history = useHistory();
  const { selectedOrganization } = useOrganizations();
  const { selectedProperty, setSelectedProperty, properties, isFetchingProperties } = useProperties();
  const [localSelectedProp] = useState(selectedProperty?.id);

  const handleSelectOne = (property, path) => {
    if (property?.id) {
      setSelectedProperty(property.id);
    }
    history.push(path);
  };

  const organizationProperties = _.filter(properties, { organization_id: selectedOrganization.id });

  const tableHeader = [
    {
      alias: 'name',
      sortable: true,
      mobilePreview: true,
      mobileInfo: true,
      format: 'string',
      dataAlias: 'name',
      dataRender: (s) => (
        <div
          className={classes.nameCell}
          onClick={() => {
            handleSelectOne(s, `/properties/update/${s.id}`);
          }}
        >
          <div>
            {s.name ? s.name : t('nameless')}
            <div className={classes.visibleSmall}>{s.email}</div>
          </div>
        </div>
      ),
    },

    {
      alias: 'actions',
      sortable: false,
      format: 'string',
      dataAlias: 'view',
      dataRender: (s) => (
        <>
          <Button
            className={classes.buttonFormat}
            component={RouterLink}
            color="primary"
            size="small"
            variant="outlined"
            to="/fields"
            onClick={() => {
              handleSelectOne(s, '/fields');
            }}
          >
            {t('view_fields')}
          </Button>
        </>
      ),
    },
  ];

  return mobileView ? (
    <MobileTable
      title={t('properties_all')}
      tableHeader={tableHeader}
      data={organizationProperties}
      selectRow={handleSelectOne}
    />
  ) : (
    <div {...rest} className={clsx(classes.root, className)}>
      <SimpleTable
        title={t('properties_all')}
        tableHeader={tableHeader}
        data={organizationProperties}
        isLoading={isFetchingProperties}
        selected={localSelectedProp}
        selectRow={handleSelectOne}
      />
    </div>
  );
}

PropertyTable.propTypes = {
  className: PropTypes.string,
};

PropertyTable.defaultProps = {
  className: undefined,
};

export default PropertyTable;
